import { Reducer } from "redux";

import { PostPutServiceRequestResponse } from "../models/Api/Service";
import { PostPutServiceRequestDispatchTypes } from "../models/DispatchTypes/Service";
import { ServiceRequestActionDispatchType } from "../constants/Service";

const initialState: PostPutServiceRequestResponse = {
  loading: false,
  response: {
    referralId: 0,
    userCreated: null,
    startOfCareDate: "",
    referralDisciplineDto: [],
    referralCareTypeDto: [],
    diseasesDto: [],
    psychologicalDiseasesDto: [],
    currentEndDate: null,
    currentStartDate: null,
    userId: 0
  },
  error: null,
};

const ServiceRequestReducer: Reducer<
  PostPutServiceRequestResponse,
  PostPutServiceRequestDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: {},
      };
    }
    case ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_RESET: {
      return {
        ...state,
        response: initialState.response,
        loading: false,
      };
    }
  }
  return state;
};

export default ServiceRequestReducer;
